import { create } from "zustand"
import { createJSONStorage, devtools, persist } from "zustand/middleware"

interface ISharedMedicalRecordNoteStore {
  notesByPatientId: Record<string, string>
  previewedSharedMedicalRecordPatientId: string | null
}

interface SharedMedicalRecordNoteStoreActions {
  setSharedMedicalRecordNote: (patientId: string, note: string) => void
  removeSharedMedicalRecordNote: (patientId: string) => void
  setPreviewedSharedMedicalRecordPatientId: (previewedSharedMedicalRecordPatientId: string | null) => void
  clearStore: VoidFunction
}

const initialState: ISharedMedicalRecordNoteStore = {
  notesByPatientId: {},
  previewedSharedMedicalRecordPatientId: null,
}

const useSharedMedicalRecordNoteStore = create<ISharedMedicalRecordNoteStore & SharedMedicalRecordNoteStoreActions>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        setSharedMedicalRecordNote: (patientId, note) =>
          set({ notesByPatientId: { ...get().notesByPatientId, [patientId]: note } }),
        removeSharedMedicalRecordNote: (patientId) => {
          const remainingNotes = { ...get().notesByPatientId }
          delete remainingNotes[patientId]
          set({ notesByPatientId: remainingNotes })
        },
        setPreviewedSharedMedicalRecordPatientId: (previewedSharedMedicalRecordPatientId) =>
          set({ previewedSharedMedicalRecordPatientId }),
        clearStore: () => set(initialState),
      }),
      {
        name: "sharedMedicalRecordNoteStore",
        storage: createJSONStorage(() => sessionStorage),
        partialize: (state) => ({ notesByPatientId: state.notesByPatientId }),
      },
    ),
  ),
)

export { useSharedMedicalRecordNoteStore }
